import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ISubFunctionFormData } from '../../api/types/leadership';

interface ISubFunctionVLModalProps {
  isOpen: boolean;
  modalType: 'add' | 'edit';
  initialValues: ISubFunctionFormData;
}

const initialState: ISubFunctionVLModalProps = {
  isOpen: false,
  modalType: 'add',
  initialValues: {
    fieldValue: '',
    functionId: '',
    code: '',
    id: '',
    functionFieldValue: '',
    systemName: '',
    abbreviation: '',
    subFunctionFamily: '',
  },
};

const subFunctionVLClientModalSlice = createSlice({
  name: 'subFunctionVLClientModal',
  initialState,
  reducers: {
    closeSubFunctionVLClientModal: () => ({
      ...initialState,
      isOpen: false,
    }),
    openAddSubFunctionVLClientModal: () => ({
      ...initialState,
      isOpen: true,
    }),
    openEditSubFunctionVLClientModal: (
      state,
      action: PayloadAction<ISubFunctionFormData>
    ) => {
      state.isOpen = true;
      state.modalType = 'edit';
      state.initialValues = {
        fieldValue: action.payload.fieldValue || '',
        functionId: action.payload.functionId || '',
        code: action.payload.code || '',
        id: action.payload.id || '',
        functionFieldValue: action.payload.functionFieldValue || '',
        systemName: action.payload.systemName || '',
        abbreviation: action.payload.abbreviation || '-',
        subFunctionFamily: action.payload.subFunctionFamily || '-',
      };
    },
  },
});

export const subFunctionVLClientModalActions =
  subFunctionVLClientModalSlice.actions;
export const subFunctionVLClientModalReducer =
  subFunctionVLClientModalSlice.reducer;
